/**
 * @module app.config.public
 */

class Controller {
  /**
  * @param {angularGettext.Catalog} gettextCatalog
  * @ngInject
  */
  constructor(gettextCatalog) {
    /**
    * @type {boolean}
    * @export
    */
    this.public;

    /**
    * @type {function(appx.PublicChangeEvent)}
    * @export
    */
    this.onChange;

    this.gettextCatalog = gettextCatalog;
  }

  /**
  * @export
  */
  setPublic() {
    this.onChange({public: this.public});
  }
}


/**
 * @const {!angular.Component}
 */
const component = {
  bindings: {
    'public': '<',
    'onChange': '&',
  },
  controller: Controller,
  templateUrl: 'js/app/config/public/partial.html'
};

export default angular.module('appConfigPublicComponent', []).component('appConfigPublic', component);
